import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { CreatePatternDto, PatternDto } from '../types';

export const useCreatePattern = (projectUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<PatternDto, Error, CreatePatternDto>({
    mutationFn: (data) => apiClient.post(`/v1/projects/${projectUuid}/patterns`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patterns', projectUuid] });
    },
  });
};
